import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e579ae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cubes me-2" }),
    /*#__PURE__*/_createTextVNode("ผลการดำเนินการโครงการ")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "แสดงรายละเอียดผลการดำเนินการโครงการ")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-coins" })
], -1))
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProjectSummaryComponent = _resolveComponent("ProjectSummaryComponent")!
  const _component_ResultProjectTypeComponent = _resolveComponent("ResultProjectTypeComponent")!
  const _component_ResultResponseComponent = _resolveComponent("ResultResponseComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFiscalYear) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fiscalYearChange && _ctx.fiscalYearChange(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fiscalYears, (fiscalYear) => {
              return (_openBlock(), _createElementBlock("option", {
                key: fiscalYear.id,
                value: fiscalYear
              }, _toDisplayString(fiscalYear.name), 9, _hoisted_7))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.selectedFiscalYear]
          ])
        ])
      ]),
      _createVNode(_component_ProjectSummaryComponent, {
        "fiscal-year": _ctx.selectedFiscalYear,
        "is-file": true
      }, null, 8, ["fiscal-year"]),
      (_ctx.selectedFiscalYear)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_ResultProjectTypeComponent, {
              "fiscal-year": _ctx.selectedFiscalYear,
              mode: "OFFICER"
            }, null, 8, ["fiscal-year"]),
            _createVNode(_component_ResultResponseComponent, {
              "fiscal-year": _ctx.selectedFiscalYear,
              mode: "OFFICER"
            }, null, 8, ["fiscal-year"])
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}